import { render } from "./ste_claves.vue?vue&type=template&id=a0b3e57c"
import script from "./ste_claves.vue?vue&type=script&lang=js"
export * from "./ste_claves.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__